module.exports = __webpack_public_path__ + "fonts/Satoshi-Light.af027aa.woff2";